﻿
export const LanguageCode = {
    English: "en",
    Chinese: "zh",
    Spanish: "es",
    German: "de",
    French: "fr",
    Polish: "pl",
    Italian: "it",
    Turkish: "tr"
};
export const LanguageRes = [
    { en: 'Invalid Format', zh: '格式错误', es: 'Formato Inválido', de: 'Ungültiges Format', fr: 'Format Invalide', pl: 'Nieprawidłowy format.', it: 'Formato non valido', tr: 'Geçersiz Format' }
]

export function geti18n(code: string) {
    const language = (<HTMLInputElement>document.querySelector('#GLOBAL_LANGUAGE_CODE')).value;
    const item = LanguageRes.find(m => m.en === code);
    if (item) {
        return item[language ?? LanguageCode.English]
    }

    return code;
}
